$(function () {
  $(window).on("load scroll resize", function () {
    var st = $(window).scrollTop();
    var wh = $(window).height();

    $(".Tips .contents ul li").each(function (i) {
      var tg = $(this).offset().top;
      var id = $(this).attr("id");

      if (st > tg - wh + wh / 2) {
        $(".Tips .nav li").removeClass("active");
        $(".Tips .nav li a span").removeClass("m-number");
        var link = $(".Tips .nav li a[href *= " + id + "]");
        $(link).parent().addClass("active");
        $(link).children("span").addClass("m-number");
      }
    });
  });

  // 診断機能
  window.diagnosisState = {
    currentQuestion: 1,
    selectedType: "",
    selectedStyle: "",
    selectedPriority: "",
    history: [], // 履歴を追加
  };

  // 診断オプションのクリックイベント
  $(".diagnosis-option").on("click", function () {
    const $this = $(this);
    const question = $this.closest(".diagnosis-question");
    const questionNum = parseInt(question.data("question"));

    // クリック効果を追加
    $this.addClass("selected");

    // 現在の状態を履歴に保存
    window.diagnosisState.history.push({
      question: window.diagnosisState.currentQuestion,
      type: window.diagnosisState.selectedType,
      style: window.diagnosisState.selectedStyle,
      priority: window.diagnosisState.selectedPriority,
    });

    // 選択した値を保存
    if (questionNum === 1) {
      window.diagnosisState.selectedType = $this.data("type");
    } else if ($this.data("style")) {
      window.diagnosisState.selectedStyle = $this.data("style");
    } else if ($this.data("priority")) {
      window.diagnosisState.selectedPriority = $this.data("priority");
    }

    // 少し遅延してからアニメーション付きで次の質問に進む
    setTimeout(() => {
      nextQuestionWithAnimation();
    }, 200);
  });

  function nextQuestion() {
    $(".diagnosis-question.active").removeClass("active");

    if (window.diagnosisState.currentQuestion === 1) {
      // Q1の後、タイプに応じてQ2を表示
      window.diagnosisState.currentQuestion = 2;
      $(
        `.diagnosis-question[data-question="2"][data-for="${window.diagnosisState.selectedType}"]`
      ).addClass("active");
    } else if (window.diagnosisState.currentQuestion === 2) {
      if (window.diagnosisState.selectedType === "open-ear") {
        // オープンイヤーの場合はQ3へ
        window.diagnosisState.currentQuestion = 3;
        $(
          `.diagnosis-question[data-question="3"][data-for="${window.diagnosisState.selectedType}"]`
        ).addClass("active");
      } else {
        // TWS、ヘッドホンの場合は結果表示
        showResult();
      }
    } else if (window.diagnosisState.currentQuestion === 3) {
      // Q3の後は結果表示
      showResult();
    }
  }

  // アニメーション付きの質問遷移
  function nextQuestionWithAnimation() {
    const currentQuestion = $(".diagnosis-question.active");

    // 現在の質問をフェードアウト
    currentQuestion.addClass("fade-out");

    setTimeout(() => {
      currentQuestion.removeClass("active fade-out");

      // 次の質問を決定
      let nextQuestion;
      if (window.diagnosisState.currentQuestion === 1) {
        window.diagnosisState.currentQuestion = 2;
        nextQuestion = $(
          `.diagnosis-question[data-question="2"][data-for="${window.diagnosisState.selectedType}"]`
        );
      } else if (window.diagnosisState.currentQuestion === 2) {
        if (window.diagnosisState.selectedType === "open-ear") {
          window.diagnosisState.currentQuestion = 3;
          nextQuestion = $(
            `.diagnosis-question[data-question="3"][data-for="${window.diagnosisState.selectedType}"]`
          );
        } else {
          showResultWithAnimation();
          return;
        }
      } else if (window.diagnosisState.currentQuestion === 3) {
        showResultWithAnimation();
        return;
      }

      // 次の質問をフェードイン
      if (nextQuestion) {
        nextQuestion.addClass("active fade-in");
        setTimeout(() => {
          nextQuestion.removeClass("fade-in");
        }, 500);
      }
    }, 300);
  }

  // アニメーション付きの結果表示
  function showResultWithAnimation() {
    let resultProduct = "";

    // 診断結果のロジック
    if (window.diagnosisState.selectedType === "tws") {
      if (window.diagnosisState.selectedPriority === "sound-noise") {
        resultProduct = "Liberty 4 Pro";
      } else if (window.diagnosisState.selectedPriority === "features") {
        resultProduct = "Liberty 5";
      } else if (window.diagnosisState.selectedPriority === "battery") {
        resultProduct = "P40i";
      }
    } else if (window.diagnosisState.selectedType === "open-ear") {
      if (window.diagnosisState.selectedStyle === "accessory") {
        if (window.diagnosisState.selectedPriority === "sound-comfort") {
          resultProduct = "AeroClip";
        } else if (window.diagnosisState.selectedPriority === "features-easy") {
          resultProduct = "C40i";
        }
      } else if (window.diagnosisState.selectedStyle === "hook") {
        if (window.diagnosisState.selectedPriority === "sound-comfort") {
          resultProduct = "AeroFit 2";
        } else if (window.diagnosisState.selectedPriority === "features-easy") {
          resultProduct = "V40i";
        }
      }
    } else if (window.diagnosisState.selectedType === "headphone") {
      if (window.diagnosisState.selectedPriority === "sound-noise-headphone") {
        resultProduct = "Space One Pro";
      } else if (
        window.diagnosisState.selectedPriority === "features-headphone"
      ) {
        resultProduct = "Space One";
      }
    }

    // 結果を表示
    displayResultWithAnimation(resultProduct);
  }

  function showResult() {
    let resultProduct = "";

    // 診断結果のロジック
    if (window.diagnosisState.selectedType === "tws") {
      if (window.diagnosisState.selectedPriority === "sound-noise") {
        resultProduct = "Liberty 4 Pro";
      } else if (window.diagnosisState.selectedPriority === "features") {
        resultProduct = "Liberty 5";
      } else if (window.diagnosisState.selectedPriority === "battery") {
        resultProduct = "P40i";
      }
    } else if (window.diagnosisState.selectedType === "open-ear") {
      if (window.diagnosisState.selectedStyle === "accessory") {
        if (window.diagnosisState.selectedPriority === "sound-comfort") {
          resultProduct = "AeroClip";
        } else if (window.diagnosisState.selectedPriority === "features-easy") {
          resultProduct = "C40i";
        }
      } else if (window.diagnosisState.selectedStyle === "hook") {
        if (window.diagnosisState.selectedPriority === "sound-comfort") {
          resultProduct = "AeroFit 2";
        } else if (window.diagnosisState.selectedPriority === "features-easy") {
          resultProduct = "V40i";
        }
      }
    } else if (window.diagnosisState.selectedType === "headphone") {
      if (window.diagnosisState.selectedPriority === "sound-noise-headphone") {
        resultProduct = "Space One Pro";
      } else if (
        window.diagnosisState.selectedPriority === "features-headphone"
      ) {
        resultProduct = "Space One";
      }
    }

    // 結果を表示
    displayResult(resultProduct);
  }

  function displayResult(productName) {
    const productHandle = window.diagnosisMapping[productName];
    const productData = window.diagnosisProductData[productHandle];

    if (productData) {
      const resultHTML = `
                <img src="${productData.image}" alt="${productData.title}" class="product-image">
                <div class="product-info">
                  <div class="product-title">${productData.title}</div>
                  <div class="product-price">${productData.price}</div>
                  <a href="${productData.url}" class="product-link">製品詳細を見る</a>
                </div>
            `;

      $(".result-product").html(resultHTML);
    }

    // 質問を隠して結果を表示
    $(".diagnosis-questions").hide();
    $(".diagnosis-result").addClass("active");
  }

  // アニメーション付きの結果表示
  function displayResultWithAnimation(productName) {
    const productHandle = window.diagnosisMapping[productName];
    const productData = window.diagnosisProductData[productHandle];

    if (productData) {
      const resultHTML = `
                <img src="${productData.image}" alt="${productData.title}" class="product-image">
                <div class="product-info">
                  <div class="product-title">${productData.title}</div>
                  <div class="product-price">${productData.price}</div>
                  <a href="${productData.url}" class="product-link">製品詳細を見る</a>
                </div>
            `;

      $(".result-product").html(resultHTML);
    }

    // アニメーション付きで結果を表示
    $(".diagnosis-questions").fadeOut(400, () => {
      $(".diagnosis-result").addClass("active fade-in");
      setTimeout(() => {
        $(".diagnosis-result").removeClass("fade-in");
      }, 600);
    });
  }
});

// 戻る機能
function goBackDiagnosis() {
  // 履歴がない場合は何もしない
  if (window.diagnosisState.history.length === 0) {
    return;
  }

  const currentQuestion = $(".diagnosis-question.active");

  // 現在の質問をフェードアウト
  currentQuestion.addClass("fade-out");

  setTimeout(() => {
    // 前の状態を復元
    const previousState = window.diagnosisState.history.pop();
    window.diagnosisState.currentQuestion = previousState.question;
    window.diagnosisState.selectedType = previousState.type;
    window.diagnosisState.selectedStyle = previousState.style;
    window.diagnosisState.selectedPriority = previousState.priority;

    // 現在の質問を隠す
    currentQuestion.removeClass("active fade-out");

    // 全ての選択済み状態をリセット
    $(".diagnosis-option").removeClass("selected");

    // 前の質問を表示
    let previousQuestion;
    if (window.diagnosisState.currentQuestion === 1) {
      previousQuestion = $('.diagnosis-question[data-question="1"]');
    } else if (window.diagnosisState.currentQuestion === 2) {
      previousQuestion = $(
        `.diagnosis-question[data-question="2"][data-for="${window.diagnosisState.selectedType}"]`
      );
    } else if (window.diagnosisState.currentQuestion === 3) {
      previousQuestion = $(
        `.diagnosis-question[data-question="3"][data-for="${window.diagnosisState.selectedType}"]`
      );
    }

    // 前の質問をアニメーション付きで表示
    if (previousQuestion) {
      previousQuestion.addClass("active fade-in");
      setTimeout(() => {
        previousQuestion.removeClass("fade-in");
      }, 500);
    }
  }, 300);
}

// 診断をリスタートする関数
function restartDiagnosis() {
  // 結果画面をフェードアウト
  $(".diagnosis-result").removeClass("active");

  setTimeout(() => {
    // 変数をリセット
    window.diagnosisState = {
      currentQuestion: 1,
      selectedType: "",
      selectedStyle: "",
      selectedPriority: "",
      history: [],
    };

    // 表示をリセット
    $(".diagnosis-question").removeClass("active fade-in fade-out");
    $(".diagnosis-result").removeClass("active fade-in");

    // 全ての選択済み状態をリセット
    $(".diagnosis-option").removeClass("selected");

    // 質問コンテナを表示して最初の質問を表示
    $(".diagnosis-questions").show();
    const firstQuestion = $('.diagnosis-question[data-question="1"]');
    firstQuestion.addClass("active fade-in");

    setTimeout(() => {
      firstQuestion.removeClass("fade-in");
    }, 500);
  }, 300);
}
